<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <base-button
        type="primary"
        round
        icon
        class="top-button-back"
        @click="$router.push('list')"
      >
        <i class="fa fa-arrow-left"></i>
      </base-button>

      <h2 v-if="!isEdit" class="text-center">Add Organizers</h2>
      <h2 v-if="isEdit" class="text-center">Edit Event</h2>
    </div>
    <div class="row">
      <div class="col-md-8">
        <card>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(submit)">
              <div class="row">
                <div class="mt-4 col-md-6">
                  <ValidationProvider
                    name="email"
                    rules="required|email"
                    v-slot="{ passed, failed, errors }"
                  >
                    <base-input
                      required
                      type="email"
                      label="Email"
                      placeholder="Email"
                      v-model="username"
                      :error="errors[0]"
                      :class="[
                        { 'has-success': passed },
                        { 'has-danger': failed },
                      ]"
                    >
                    </base-input>
                  </ValidationProvider>
                </div>

                <div class="mt-4 col-md-6">
                  <ValidationProvider
                    name="text"
                    rules="required"
                    v-slot="{ passed, failed, errors }"
                  >
                    <base-input
                      required
                      type="text"
                      label="Display Name"
                      placeholder="Display Name"
                      v-model="displayname"
                      :error="errors[0]"
                      :class="[
                        { 'has-success': passed },
                        { 'has-danger': failed },
                      ]"
                    >
                    </base-input>
                  </ValidationProvider>
                </div>
                <div class="mt-4 col-md-6">
                  <ValidationProvider
                    name="password"
                    rules="required|min:5"
                    v-slot="{ passed, failed, errors }"
                  >
                    <base-input
                      required
                      label="Password"
                      v-model="password"
                      placeholder="Password"
                      type="password"
                      :error="errors[0]"
                      :class="[
                        { 'has-success': passed },
                        { 'has-danger': failed },
                      ]"
                    >
                    </base-input>
                  </ValidationProvider>
                </div>
              </div>
              <div class="row" style="padding: 30px"></div>

              <base-button
                v-if="!isEdit"
                native-type="submit"
                type="primary"
                class="btn-fill float-right"
                :disabled="loading"
                @click="Organisze()"
                >Save</base-button
              >

              <base-button
                v-if="isEdit"
                native-type="submit"
                type="primary"
                @click="Update()"
                class="btn-fill  float-right"
                :disabled="loading"
                >Update</base-button
              >

              <div class="row" style="padding: 10px"></div>
            </form>
          </ValidationObserver>
        </card>
      </div>
    </div>

    <div class="full-screen-loader" v-if="loading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal, BaseAlert } from "src/components";

import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";

extend("email", email);
extend("min", min);

extend("required", required);

export default {
  components: {
    Modal,
    BaseAlert,
  },
  data() {
    return {
      isEdit: false,
      username: "",
      password: "",
      displayname: "",
      loading: false,

      regexPassword: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{5,}$/,
      filter: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
    };
  },

  async mounted() {
    debugger;
    console.log(this.$route.query.id);
    var id = this.$route.query.id;
    if (id == -1) {
      this.isEdit = false;
    } else {
      this.isEdit = true;
      let admin = await this.$apiService.postCall("admin/getAdmin", {
        _id: id,
      });
      debugger;
      console.log(admin);
      this.username = admin.apidata.data.username;
      this.displayname = admin.apidata.data.displayname;
      this.password = admin.apidata.data.password;
    }
  },

  methods: {
    async Organisze() {
      var id = this.$route.query.id;
      if (!this.username && !this.password && !this.displayname) {
        this.$apiService.notify("All fields are mandatory.");
        return;
      }

      if (!this.username) {
        this.$apiService.notify("User Name is mandatory.");
        return;
      }

       if (!this.filter.test(this.username)) {
        this.$apiService.notify("Please provide a valid email address.");
        return;
      }

      if (!this.password) {
        this.$apiService.notify("Password is mandatory.");
        return;
      }

      if (!this.displayname) {
        this.$apiService.notify("Display Name is mandatory.");
        return;
      }


      if (!this.regexPassword.test(this.password)) {
        this.$apiService.notify(
          "Password should have atleast 5 characters and should contain 1 special charcter, 1 upper case, 1 lower case and 1 number."
        );
        return;
      }

     

      this.loading = true;
      var Organisze = {
        username: this.username,
        password: this.password,
        displayname: this.displayname,
      };

      var update_eve = await this.$apiService.postCall(
        "admin/addAdmin",
        Organisze
      );
      console.log(update_eve);
      this.$apiService.notify("Event Organizer has been added.");
      debugger;
      this.$router.push("/organizers/list");
    },

    async Update() {
      if (!this.regexPassword.test(this.password)) {
        await $apiService.presentToastWithOptions(
          "Password should have atleast 5 characters Long and should contain 1 special charcter, 1 upper case, 1 lower case and 1 number."
        );
        return;
      }

      var id = this.$route.query.id;
      if (!this.password && !this.username && !this.displayname) {
        this.$apiService.notify("All fields are mandatory.");
        return;
      }

      if (!this.username) {
        this.$apiService.notify("User Name is mandatory.");
        return;
      }

      if (!this.password) {
        this.$apiService.notify("Password is mandatory.");
        return;
      }
      if (!this.displayname) {
        this.$apiService.notify("Display Name is mandatory.");
        return;
      }

      this.loading = true;
      var Update = {
        username: this.username,
        password: this.password,
        displayname: this.displayname,
      };

      var update = await this.$apiService.postCall(
        "admin/updateAdmin/" + id,
        Update
      );
      console.log(update);
      debugger;

      this.$apiService.notify("Event Organizer has been Updated.");
      debugger;
      this.$router.push("/organizers/list");
    },

    // async DeletePass() {
    //   debugger;
    //   var del = confirm("Do You Really Want To Delete");
    //   if (del) {
    //     const id = this.$route.query.id;

    //     const del_pas = await this.$apiService.postCall("admin/deleteAdmin/", {
    //       _id: id,
    //     });
    //     debugger;
    //     // console.log(deld);

    //     this.$apiService.notify("Data has been deleted.");
    //     this.$router.push("/organizers/list");
    //   }
    // },
  },
};
</script>

<style>
.location {
  background: #27293d;
  border: 1px solid #2b3553;
  padding: 8px;
  font-size: 14px;
  border-radius: 5px;
  width: 100%;
  color: white;
}
form label {
  font-weight: 600;
}

.coordinate {
  background: #27293d;
  border: 1px solid #2b3553;
  padding: 5px;
  font-size: 14px;
  border-radius: 5px;
  color: white;
}
</style>
